module.exports = __webpack_public_path__ + "de2081656e914e4d5fb845422d3b09e1.jpg";